import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import axios from 'axios';
import sweetalert from 'sweetalert';
import { confirm } from "react-confirm-box";
import CreateCadmin from './CreateCadmin';

const options = {
    labels: {
      confirmable: "Confirm",
      cancellable: "Cancel"
    }
  }

class ListCAdmin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            creatingCadmin: false,
            List: []
        }
    }
    componentDidMount() {
        this.getTotalCAdmin()
    }
    getTotalCAdmin = () => {
        let _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        var data = {
            simulanis_id: ud.id
        }
        let url = `${SERVER_IP}/corporatesList`;
        // For CAdmin in Corporate Admin Dashboard
        if (ud && ud.usertype === 1) {
            data = {
                c_id: ud.main_id,
                admin_type:"cadmin"
            }
            url = `${SERVER_IP}/multi/admin/list`;
        }

        axios.post(url, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error === false) {
                    // For CAdmin in Corporate Admin Dashboard
                    if (ud && ud.usertype === 1) {
                        if (response.data.result) {
                            _this.setState({ List: response.data.result });
                        }
                    } else {
                        if (response.data.corporatesList) {
                            _this.setState({ List: response.data.corporatesList });
                        }
                    }
                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getTotalCAdmin();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    onChangeInput = (e) => {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value })
    }
    handleImageChange = (e) => {
        e.preventDefault();
        if (!e.target.files[0]) {
            return
        }
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            this.setState({
                logo: reader.result
            });

        };
    }
    createCorporateAdmin = () => {
        window.location.href = "/create/cadmin"
    }
    manageEvent = (list) => {
        sessionStorage.setItem('listlicense', list.id)
        window.location.href = "/create/listlicense"
    }

    deleteCadmin = async(e) =>{
        const result = await confirm("Do you really want to delete this ?",options);
       if(result){
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
              }
           var data={
                  c_id:e
                   }
           axios.post(`${SERVER_IP}/cadminDelete`, data, {withCredentials: true, headers: headers })
           .then(function (response) {
               if (response.data.error === false) {
                sweetalert("User deleted successfully.")
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
               } else {
                  
               }
           })
           .catch(function (error) {
               console.log(error);
           });
       }
    }


    render() {

        const { errors } = this.state;
        return (
            <div>
                <div class="xp-breadcrumbbar">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">
                            <h4 class="xp-page-title">List Of Corporate Admins</h4>
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <div class="xp-breadcrumb">
                                <ol class="breadcrumb">
                                    <button className="btn btn-primary btn-lg active" onClick={this.createCorporateAdmin}>Create Corporate Admin</button>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="xp-contentbar">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card m-b-30">

                                <div class="card-header bg-white">
                                    <h5 class="card-title text-black mb-0">Corporates Admin List</h5>
                                </div>

                                <div class="card-body">
                                    <div class="table-responsive">
                                        <table class="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "5%" }}>No</th>
                                                    <th>Cooperate Name</th>
                                                    {/* <th>Logo</th> */}
                                                    <th>Details</th>
                                                    <th>Location Name</th>
                                                    <th>License Staus</th>
                                                    <th>Storage Type</th>
                                                    <th>Storage</th>
                                                    {ud && ud.usertype === 0 && <th>License</th>}
                                                    <th>Delete</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.List.map((list, index) =>
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td>{list.cooperate_name}</td>
                                                        {/* <td><img src={`http://simulanis.in:3004/`} /></td> */}
                                                        <td>{list.details}</td>
                                                        <td>{list.location_name}</td>
                                                        <td style={{ textAlign: "center" }}>{list.activated_license == 1 ? <i class="fa fa-check-circle text-success center"></i> : <i class="fa fa-times-circle text-danger"></i>}</td>
                                                        <td>{list.storage_type ? list.storage_type : "N.A"}</td>
                                                        <td>{list.total_storage ?  `${list.total_storage_usage} / ${list.total_storage}` : "N.A"} </td>
                                                        {ud && ud.usertype === 0 && <td><button className="btn btn-primary btn-lg active" onClick={() => this.manageEvent(list)}>Manage</button></td>}
                                                        <td><button className="btn btn-primary btn-lg active" onClick={() => this.deleteCadmin(list.id)}>Delete</button></td>

                                                    </tr>
                                                )}

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>


                </div>
            </div>
        )
    }
}
export default ListCAdmin

